import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { Id as CustomerId } from '../../customer';

export const Customer = struct({
	equalsType: EqualsType,
	values: array(CustomerId),
});
